import type { SystemStyleObject } from '@chakra-ui/react'
import { Box } from '@chakra-ui/react'
import React from 'react'

export const TableWrapper = ({
  children,
  sx,
}: {
  children: React.ReactNode
  sx?: SystemStyleObject
}) => {
  return (
    <Box sx={{ maxW: '100%', overflow: 'hidden', overflowX: 'auto', ...sx }}>
      {children}
    </Box>
  )
}
